import React, { useEffect } from "react";

import "./Topbar.style.css";

const Topbar = () => {
  const hideTopBar = function (evt) {
    if (window.pageYOffset > 200) {
      document.getElementById("topbar").style.top = "-40px";
      document.getElementById("navbar").style.top = "0";
      if (document.getElementById("mobile-nav")) {
        document.getElementById("mobile-nav").style.top = "54.5px";
      }
    } else {
      document.getElementById("topbar").style.top = "0px";
      document.getElementById("navbar").style.top = "40px";
      if (document.getElementById("mobile-nav")) {
        document.getElementById("mobile-nav").style.top = "95px";
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", hideTopBar, { passive: true });
    return () => {
      window.removeEventListener("scroll", hideTopBar);
    };
  }, []);

  return (
    <div className="d-lg-block d-none">
      <div id="topbar" className="fixed-top topbar">
        <div className="py-2 container ">
          <div className="languages d-flex align-items-center justify-content-end">
            <select className="languageSelector">
              <option value="ar">AR</option>
              <option value="en">EN</option>
              <option value="es">ES</option>
              <option value="fr">FR</option>
              <option value="gj">GJ</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
